/*
  clikt. — availability guardrail.

  Ready-to-dispatch stock hides in the picker two ways:
    - a hidden "Availability" row (2-option products), or
    - a hidden value like "… — Ready to dispatch" inside the finish row
      (products already using all three of Shopify's option slots).
  Either way the ⚡ Need-it-sooner panel is the only visible doorway.

  The trap: someone on the in-stock unit changes size or finish and drifts
  onto a combination that doesn't exist.

  Timing is the whole trick. We correct the hidden selection during the
  CLICK's capture phase — before the browser fires `change` and before Dawn
  re-renders the section. Dawn then reads an already-correct picker and
  draws the made-to-order state once. Doing it after the change instead
  caused a double render where the price updated but the lead-time block
  kept showing READY TO DISPATCH.
*/
(function () {
  if (window.cliktAvailabilityGuard) return;
  window.cliktAvailabilityGuard = true;

  var MARKER = 'ready to dispatch';

  function isRts(value) {
    return (value || '').toLowerCase().indexOf(MARKER) !== -1;
  }

  // Strip the marker to get the plain made-to-order twin of a value.
  function twinOf(value) {
    return (value || '')
      .replace(/\s*[—–-]?\s*Ready to dispatch\s*$/i, '')
      .trim();
  }

  document.addEventListener(
    'click',
    function (event) {
      var input = event.target.closest && event.target.closest('input[type="radio"], label');
      if (!input) return;

      var picker = input.closest('variant-selects');
      if (!picker || !picker.dataset.cliktRtsO1) return;

      // A click inside the hidden row is the panel doing its job — allow it.
      var ownRow = input.closest('fieldset, .product-form__input--dropdown');
      if (ownRow && ownRow.classList.contains('clikt-hidden-option')) return;

      // Resolve the actual radio behind a label click.
      var radio = input;
      if (input.tagName === 'LABEL') {
        var id = input.getAttribute('for');
        radio = id ? picker.querySelector('#' + CSS.escape(id)) : input.querySelector('input');
      }
      if (!radio || radio.type !== 'radio') return;

      // Clicking the in-stock value itself is intentional — allow it.
      if (isRts(radio.value)) return;

      // Case A — hidden Availability row currently set to Ready to dispatch.
      var hiddenRow = picker.querySelector('.clikt-hidden-option');
      if (hiddenRow) {
        var current = hiddenRow.querySelector('input:checked');
        if (current && isRts(current.value)) {
          var mto = hiddenRow.querySelector('input:not([value="' + current.value.replace(/"/g, '\\"') + '"])');
          if (mto) mto.checked = true;
        }
        return;
      }

      // Case B — the marker lives on a value inside a visible row.
      var marked = null;
      var checkedInputs = picker.querySelectorAll('input:checked');
      for (var i = 0; i < checkedInputs.length; i++) {
        if (isRts(checkedInputs[i].value)) { marked = checkedInputs[i]; break; }
      }
      if (!marked) return;

      var twin = twinOf(marked.value);
      if (!twin) return;

      var name = (marked.getAttribute('name') || '').replace(/"/g, '\\"');
      var replacement = picker.querySelector(
        'input[name="' + name + '"][value="' + twin.replace(/"/g, '\\"') + '"]'
      );
      if (replacement) replacement.checked = true;
    },
    true // capture — run before change fires and before Dawn re-renders
  );
})();
